import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import './App.css';
import './Menu.css';

function Menu(props) {

  const [t, i18n] = useTranslation();

  return (
    <div className="Menu">
      <div className="MenuTitle">
        <b>{t('IOSTちゃん')}</b>
        {t('の')}<br></br>
        <b>{t('アカウント工房')}</b>
      </div>
      <div className='MenuImg'></div>

      <button className="Menu" onClick={() => props.pg(`make`)}>
        🍭{t('アカウントをつくる')}
      </button>
      <button className="Menu" onClick={() => props.pg(`srch`)}>
        👀{t('アカウントをしらべる')}
      </button>
      <button className="Menu" onClick={() => props.pg(`info`)}>
        🔰{t('このサービスについて')}
      </button>


    </div>
  );
}

export default Menu;